<template>
  <div id="app">
    <div id="app-wrap" class="position-relative">
      <aside
        id="sidebar"
        v-bind:class="{ 'mini-sidebar': isToggled, offset: isOffset }"
        v-show="
          isLogin &&
          !subIsActive('/setup') &&
          !subIsActive('/maintenance') &&
          !subIsActive('/404') &&
          isSidebar
        "
      >
        <div id="merchant-wrap" v-if="moduleList">
          <div id="merchant-logo">
            <img
              src="./assets/images/defaultlogo.svg"
              alt=""
              class="default-img"
            />
          </div>
          <p id="merchant-name">{{ detail.name }}</p>
          <ul id="sidebar-nav">
            <li
              class="nav-li"
              v-if="!restrictMarketplace() && hasAccess('analytics.')"
              @click="sendAnalyticsEvent('Analytics')"
            >
              <template v-if="racksCustomized">
                <router-link
                  to="/analytics/sales"
                  class="nav-link -analytics"
                  :class="[
                    {
                      active: subIsActive('/analytics'),
                      'justify-content-center': isToggled,
                      'cursor-not-allowed': isSuspended,
                    },
                    'd-dlex flex-row te',
                  ]"
                  id="analytics"
                >
                  <div class="ic-sidenav-analytics mr-2"></div>
                  <div class="nav-label">Analytics</div>
                </router-link>
              </template>
              <template v-else>
                <router-link
                  :to="redirectTo('/analytics')"
                  class="nav-link -analytics"
                  :class="[
                    {
                      active: subIsActive('/analytics'),
                      'justify-content-center': isToggled,
                      'cursor-not-allowed': isSuspended,
                    },
                    'd-dlex flex-row te',
                  ]"
                  id="analytics"
                >
                  <div class="ic-sidenav-analytics mr-2"></div>
                  <div class="nav-label">Analytics</div>
                </router-link>
              </template>
              <b-popover
                target="analytics"
                triggers="hover"
                content="This section allows you to view the summary of your perfromance in sales, acquistion, engagement and rewards program"
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="!restrictMarketplace() && hasAccess('design.')"
              @click="sendAnalyticsEvent('Design')"
            >
              <router-link
                to="/design"
                class="nav-link -design"
                :class="[
                  {
                    active: subIsActive('/design'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="design"
                data-container="body"
              >
                <div class="ic-sidenav-design mr-2"></div>
                <div class="nav-label">Design</div>
              </router-link>
              <b-popover
                target="design"
                triggers="hover"
                content="Customize your app's design"
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="
                hasAccess('store.organization') || hasAccess('store.employee')
              "
              @click="sendAnalyticsEvent('Store')"
            >
              <router-link
                :to="redirectTo('/store')"
                class="nav-link -store"
                :class="[
                  {
                    active: subIsActive('/store'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="store"
                data-container="body"
              >
                <div class="ic-sidenav-store mr-2"></div>
                <div class="nav-label">Store</div>
              </router-link>
              <b-popover
                target="store"
                triggers="hover"
                content="Set the list of your store branches and employees in this section."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="
                hasTopup('estore') &&
                (hasAccess('estore-products.inventory:topup-estore') ||
                  hasAccess('estore-products.branch-inventory:topup-estore'))
              "
              @click="sendAnalyticsEvent('E-Store Products')"
            >
              <router-link
                :to="redirectTo('/products')"
                class="nav-link"
                :class="[
                  {
                    active: subIsActive('/products'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="products"
              >
                <div class="ic-sidenav-products mr-2"></div>
                <div class="nav-label">Products</div>
              </router-link>
              <b-popover
                target="products"
                triggers="hover"
                content="Create your own product with multiple variations and wide ranges of add-ons. Manage and monitor your own product inventory."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="hasAccess('fulfillment.') && hasTopup('estore')"
              @click="sendAnalyticsEvent('Order Fulfillment')"
            >
              <router-link
                to="/fulfillment"
                :class="[
                  'nav-link -fulfillment d-flex flex-row',
                  {
                    active: subIsActive('/fulfillment'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                ]"
                id="fulfillment"
              >
                <div class="ic-sidenav-fulfillment mr-2"></div>
                <div class="nav-label position-relative">Order Fulfillment</div>
              </router-link>
              <b-popover
                target="fulfillment"
                triggers="hover"
                content="Configure all settings for order delivery or customer pick-up."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="hasAccess('punch-card.') && hasTopup('punchcard')"
              @click="sendAnalyticsEvent('Punch Card')"
            >
              <router-link
                to="/punch-card"
                :class="[
                  'nav-link -punch-card d-flex flex-row',
                  {
                    active: subIsActive('/punch-card'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                ]"
                id="punch-card"
              >
                <div class="ic-sidenav-punch-card mr-2"></div>
                <div class="nav-label position-relative">Punch Card</div>
              </router-link>
              <b-popover
                target="punch-card"
                triggers="hover"
                content="Reward repeat purchases effortlessly! The RUSH Punch Card lets customers earn digital stamps for every qualifying transaction, unlocking exclusive rewards once they complete their card."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="
                hasTopup('estore') &&
                hasAccess('estore-orders.orders:topup-estore')
              "
              @click="sendAnalyticsEvent('E-Store Orders')"
            >
              <router-link
                :to="redirectTo('/orders')"
                class="nav-link"
                :class="[
                  {
                    active: subIsActive('/orders'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="orders"
              >
                <div class="ic-sidenav-orders mr-2"></div>
                <div class="nav-label">Orders</div>
              </router-link>
              <b-popover
                target="orders"
                triggers="hover"
                content="Process customer orders from different sales channel."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="
                hasTopup('estore') &&
                hasAccess('estore-promo-codes.vouchers:topup-estore')
              "
              @click="sendAnalyticsEvent('E-Store Promo Codes')"
            >
              <router-link
                to="/promo-codes"
                class="nav-link"
                :class="[
                  {
                    active: subIsActive('/promo-codes'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="promo-codes"
              >
                <div class="ic-sidenav-promo-codes mr-2"></div>
                <div class="nav-label">Promo Codes</div>
              </router-link>
              <b-popover
                target="promo-codes"
                triggers="hover"
                content="Create and manage your own promotional codes."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="
                hasTopup('estore') &&
                hasAccess('estore-settings.settings:topup-estore')
              "
              @click="sendAnalyticsEvent('E-Store Settings')"
            >
              <router-link
                to="/settings"
                class="nav-link"
                :class="[
                  {
                    active: subIsActive('/settings'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="settings"
              >
                <div class="ic-sidenav-settings mr-2"></div>
                <div class="nav-label">Settings</div>
              </router-link>
              <b-popover target="settings" triggers="hover" content="Settings">
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="
                hasTopup('estore') &&
                hasAccess('estore-locations.locations:topup-estore')
              "
              @click="sendAnalyticsEvent('E-Store Locations')"
            >
              <router-link
                to="/locations"
                class="nav-link"
                :class="[
                  {
                    active: subIsActive('/locations'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="locations"
              >
                <div class="ic-sidenav-locations mr-2"></div>
                <div class="nav-label">Locations</div>
              </router-link>
              <b-popover
                target="locations"
                triggers="hover"
                content="Manage your brand and branches in this section."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="!restrictMarketplace() && hasAccess('mechanics.')"
              @click="sendAnalyticsEvent('Program')"
            >
              <router-link
                :to="redirectTo('/mechanics')"
                class="nav-link -mechanics"
                :class="[
                  {
                    active: subIsActive('/mechanics'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-dlex flex-row te',
                ]"
                id="mechanics"
              >
                <div class="ic-sidenav-mechanics mr-2"></div>
                <div class="nav-label">Program</div>
              </router-link>
              <b-popover
                target="mechanics"
                triggers="hover"
                content="Customize your overall loyalty program."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="hasAccess('rewards.')"
              @click="sendAnalyticsEvent('Rewards')"
            >
              <router-link
                to="/rewards/my-rewards-v2"
                class="nav-link -rewards"
                :class="[
                  {
                    active: subIsActive('/rewards'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="rewards"
                data-container="body"
              >
                <div class="ic-sidenav-rewards mr-2"></div>
                <div class="nav-label">Rewards</div>
              </router-link>
              <b-popover
                target="rewards"
                triggers="hover"
                content="These are the items/services that registered customers can redeem in exchange for the points that they have earned."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="hasAccess('privilege-card.') && hasTopup('privilege_card')"
              @click="sendAnalyticsEvent('Privilege Card')"
            >
              <router-link
                to="/privilege-card"
                class="nav-link"
                :class="[
                  {
                    active: subIsActive('/privilege-card'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="privilege-card"
                data-container="body"
              >
                <div class="ic-sidenav-privilege-card mr-2"></div>
                <div class="nav-label">Privilege Card</div>
              </router-link>
              <b-popover
                target="privilege-card"
                triggers="hover"
                content="Create and manage privilege card bundles, publish your privilege cards to your customer channels, and view card member accounts."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="hasAccess('customers.')"
              @click="sendAnalyticsEvent('Customers')"
            >
              <router-link
                :to="redirectTo('/customers')"
                class="nav-link -customers"
                :class="[
                  {
                    active: subIsActive('/customers'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="customers"
                data-container="body"
              >
                <div class="ic-sidenav-customers mr-2"></div>
                <div class="nav-label">
                  <template v-if="planId != 5"> Customers </template>
                  <template v-else> Transactions </template>
                </div>
              </router-link>
              <b-popover
                target="customers"
                :key="planId"
                triggers="hover"
                :content="
                  planId != 5
                    ? 'Manage your customers information, transaction and feedback on this section.'
                    : 'Manage your redeemed rewards, revenue and transaction information on this section.'
                "
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="hasAccess('booking:topup.') && hasTopup('booking')"
              @click="sendAnalyticsEvent('Booking')"
            >
              <router-link
                :to="redirectTo('/booking')"
                class="nav-link -booking"
                :class="[
                  {
                    active: subIsActive('/booking'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="booking"
              >
                <div class="ic-sidenav-booking mr-2"></div>
                <div class="nav-label">Booking</div>
              </router-link>
              <b-popover
                target="booking"
                triggers="hover"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="!restrictMarketplace() && hasAccess('engagement.')"
              @click="sendAnalyticsEvent('Engagement')"
            >
              <router-link
                :to="redirectTo('/engagement')"
                class="nav-link -engagement"
                :class="[
                  {
                    active: subIsActive('/engagement'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="engagement"
              >
                <div class="ic-sidenav-engagement mr-2"></div>
                <div class="nav-label">Engagement</div>
              </router-link>
              <b-popover
                target="engagement"
                triggers="hover"
                content="Connect with your registered customers via SMS, APP Push Notifications, and Email."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li position-relative"
              v-if="hasAccess('dstore:topup.') && hasTopup('dstore')"
              @click="sendAnalyticsEvent('D-Store')"
            >
              <router-link
                :to="redirectTo('/dstore')"
                :class="[
                  'nav-link -dstore d-flex flex-row',
                  {
                    active: subIsActive('/dstore'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                ]"
                id="dstore"
              >
                <div class="ic-sidenav-dstore mr-2"></div>
                <div class="nav-label">D-Store</div>
              </router-link>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="hasAccess('documents:topup.') && hasTopup('documents')"
              @click="sendAnalyticsEvent('Documents')"
            >
              <router-link
                to="/documents/"
                class="nav-link -documents"
                :class="[
                  {
                    active: subIsActive('/documents'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="documents"
              >
                <div class="ic-sidenav-documents mr-2"></div>
                <div class="nav-label">Documents</div>
              </router-link>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="hasAccess('s-wallet.') && hasTopup('wallet')"
              @click="sendAnalyticsEvent('Rush Wallet')"
            >
              <router-link
                to="/wallet/"
                class="nav-link -wallet"
                :class="[
                  {
                    active: subIsActive('/wallet'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="wallet"
              >
                <div class="ic-sidenav-wallet mr-2"></div>
                <div class="nav-label">Rush Wallet</div>
              </router-link>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="
                !restrictMarketplace() &&
                hasAccess('vouchers:topup.') &&
                hasTopup('voucher')
              "
              @click="sendAnalyticsEvent('Vouchers')"
            >
              <router-link
                to="/vouchers"
                class="nav-link -vouchers"
                :class="[
                  {
                    active: subIsActive('/vouchers'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="vouchers"
              >
                <div class="ic-sidenav-vouchers mr-2"></div>
                <div class="nav-label">Vouchers</div>
              </router-link>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="hasAccess('reports:topup.') && hasTopup('reports')"
              @click="sendAnalyticsEvent('Master Data')"
            >
              <router-link
                :to="redirectTo('/reports')"
                class="nav-link -reports"
                :class="[
                  {
                    active: subIsActive('/reports'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="reports"
              >
                <div class="ic-sidenav-reports mr-2"></div>
                <div class="nav-label">Master Data</div>
              </router-link>
              <b-popover
                target="reports"
                triggers="hover"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="showToMerchant"
              @click="sendAnalyticsEvent('Billing')"
            >
              <router-link
                to="/billing"
                class="nav-link -billing"
                :class="[
                  {
                    active: subIsActive('/billing'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="billing"
              >
                <div class="ic-sidenav-billing mr-2"></div>
                <div class="nav-label">Billing</div>
              </router-link>
              <b-popover
                target="billing"
                triggers="hover"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="hasAccess('survey:topup.') && hasTopup('survey')"
              @click="sendAnalyticsEvent('Survey')"
            >
              <router-link
                to="/survey/"
                class="nav-link -survey"
                :class="[
                  {
                    active: subIsActive('/survey'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                  'd-flex flex-row',
                ]"
                id="survey"
              >
                <div class="ic-sidenav-survey mr-2"></div>
                <div class="nav-label">Survey</div>
              </router-link>
              <b-popover
                target="survey"
                triggers="hover"
                content="Customize and publish your survey"
              >
              </b-popover>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
            <li
              class="nav-li"
              v-if="hasAccess('plugins.')"
              @click="sendAnalyticsEvent('Plugins')"
            >
              <router-link
                to="/plugins"
                :class="[
                  'nav-link -plugins d-flex flex-row',
                  {
                    active: subIsActive('/plugins'),
                    'justify-content-center': isToggled,
                    'cursor-not-allowed': isSuspended,
                  },
                ]"
                id="plugins"
              >
                <div class="ic-sidenav-plugins mr-2"></div>
                <div class="nav-label">Plugins</div>
              </router-link>
              <div class="overlay" v-if="!$store.getters['onboarding/step1AndStep2Completed']"></div>
            </li>
          </ul>
        </div>
      </aside>
      <div
        id="app-content"
        :class="{
          'login-wrap d-flex':
            !isLogin &&
            !subIsActive('/404') &&
            !subIsActive('/setup') &&
            !subIsActive('/upgrade') &&
            !subIsActive('/verify'),
          'setup-wrap':
            subIsActive('/setup') ||
            subIsActive('/upgrade') ||
            subIsActive('/verify'),
          'page-not-found-wrap': subIsActive('/404'),
        }"
      >
        <header
          id="header"
          v-if="
            isLogin &&
            !subIsActive('/404') &&
            !subIsActive('/maintenance') &&
            isHeader
          "
        >
          <div class="header-burger" v-show="!subIsActive('/setup')">
            <button v-on:click="sidebarToggle" id="menu-toggle">
              <span class="bar-top"></span>
              <span class="bar-middle"></span>
              <span class="bar-bottom"></span>
            </button>
          </div>
          <div class="rush-brand">
            <template v-if="planId != 5">
              <b-button
                variant="ghost"
                tag="a"
                href="https://www.rush.ph/"
                target="_blank"
                class="p-0 m-0"
              >
                <img src="./assets/images/rush-brand_mark.png" alt="RUSH" />
              </b-button>
            </template>
            <template v-else>
              <img src="./assets/images/zeal-logo.png" alt="RUSH" />
            </template>
          </div>
          <div class="user-menu" v-if="form">
            <template v-if="subdomain">
              <div
                class="estore-link"
                style="z-index: 9"
                v-if="env === 'Canary'"
                :class="{ 'd-none': hideMyOnlineStoreLink }"
              >
                <a
                  v-if="subdomain === 'ucoin'"
                  :href="'http://ucoin-canary.loyaltyco.xyz/' + subdomain"
                  target="_blank"
                  >MY ONLINE STORE</a
                >
                <a
                  v-else
                  :href="'http://estore-web-canary.loyaltyco.xyz/' + subdomain"
                  target="_blank"
                  >MY ONLINE STORE</a
                >
              </div>
              <div
                class="estore-link"
                style="z-index: 9"
                v-else-if="env === 'Staging'"
                :class="{ 'd-none': hideMyOnlineStoreLink }"
              >
                <a
                  v-if="subdomain === 'ucoin'"
                  :href="'http://ucoin-staging.loyaltyco.xyz/' + subdomain"
                  target="_blank"
                  >MY ONLINE STORE</a
                >
                <a
                  v-else
                  :href="'http://estore-web-staging.loyaltyco.xyz/' + subdomain"
                  target="_blank"
                  >MY ONLINE STORE</a
                >
              </div>
              <div
                class="estore-link"
                :class="{ 'd-none': hideMyOnlineStoreLink }"
                style="z-index: 9"
                v-else
              >
                <a
                  v-if="subdomain === 'ucoin'"
                  :href="'https://' + subdomain + '.rush.ph/' + subdomain"
                  target="_blank"
                  >MY ONLINE STORE</a
                >
                <a
                  v-else
                  :href="'https://estore.rush.ph/' + subdomain"
                  target="_blank"
                  >MY ONLINE STORE</a
                >
              </div>
            </template>
            <span class="user-badge d-none">
              <img
                src="./assets/images/defaultavatar.svg"
                alt="Katrina"
                class="default-img"
              />
            </span>
            <b-dropdown
              v-bind:text="user.firstname"
              variant="ghost"
              id="myaccount"
            >
              <div class="info-wrap">
                <div class="user-badge d-none">
                  <img
                    src="./assets/images/defaultavatar.svg"
                    alt=""
                    class="default-img"
                  />
                </div>
                <div class="user-info ml-0">
                  <div class="username">{{ user.firstname }}</div>
                  <div class="useremail">{{ user.email }}</div>
                </div>
              </div>
              <div class="user-actions">
                <b-dropdown-item
                  v-if="hasTopup('estore') && isAdmin"
                  :to="{ name: 'onboarding' }"
                  @click="sendAnalyticsEvent('RUSH Academy')"
                >
                  <i class="ic-rush-academy"></i> RUSH Academy
                </b-dropdown-item>
                <b-dropdown-item
                  :to="{ name: 'MyPlanDetails' }"
                  v-if="hasAccess('my-plan.')"
                  @click="sendAnalyticsEvent('My Plan')"
                >
                  <i class="ic-my-plan">
                    <MyPlanIcon fill="#2A2A2A" />
                  </i>
                  My Plan
                </b-dropdown-item>
                <b-dropdown-item
                  :to="{ path: '/account/profile' }"
                  v-bind:class="{
                    'd-none':
                      subIsActive('/setup') ||
                      subIsActive('/upgrade') ||
                      subIsActive('/verify'),
                  }"
                  @click="sendAnalyticsEvent('Account Settings')"
                >
                  <i class="ic-settings"></i> Account Settings
                </b-dropdown-item>
                <b-dropdown-item
                  :to="{ path: '/activity/logs' }"
                  @click="GAEvent('Activity Logs', 'click')"
                >
                  <i class="ic-activity-logs"></i> Activity Logs
                </b-dropdown-item>
                <b-dropdown-item @click.prevent="logout">
                  <i class="ic-logout"></i> Log Out
                </b-dropdown-item>
              </div>
            </b-dropdown>
            <div class="divider"></div>
            <a
              href="https://help.rush.ph/knowledge/news-archives"
              class="btn notifications-wrapper"
            >
              <i class="ic-notifications"></i>
            </a>
            <div class="divider"></div>
            <a
              href="https://help.rush.ph/knowledge"
              class="btn help-wrapper"
              @click="
                env === 'Production'
                  ? GAEvent('CMS Knowledge Button', 'click')
                  : null
              "
            >
              <i class="ic-help" id="knowledge-hub"></i>
              <b-popover
                target="knowledge-hub"
                triggers="hover"
                content="Got questions? Visit the RUSH Help Center for FAQs and quick guides."
              >
              </b-popover>
            </a>
          </div>
        </header>
        <div class="row" v-if="isLogin && withFreeTrial">
          <b-col lg="12" class="white py-2">
            <div class="free-trial">
              <b-badge variant="dark" class="">Free Trial</b-badge>
              <b-badge variant="secondary" class="">{{
                freeTrialDays
              }}</b-badge>

              <i class="ic-tooltip ml-2 mr-5" id="trial-help"></i>
              <b-popover
                target="trial-help"
                triggers="hover"
                content="You can use the RUSH eStore for free during the trial period. To keep your eStore active after your trial expires, upgrade to a paid subscription plan fit to your business needs."
              >
              </b-popover>
            </div>
          </b-col>
        </div>
        <b-container 
          v-if="
            isLogin &&
            hasTopup('estore') && 
            $route.name !== 'onboarding' &&
            $route.name !== 'onboarding-payout-requirements' &&
            $store.getters['onboarding/step1AndStep2Completed'] &&
            !$store.getters['onboarding/step3Completed']"
          fluid
          class="bg-white py-2"
        >
          <b-row>
            <b-col cols="11 mx-auto">
              <payout-requirements-reminder />
            </b-col>
          </b-row>
        </b-container>
        <transition :name="transitionName" mode="out-in">
          <router-view></router-view>
        </transition>
        <!-- Notifications -->
        <notifications
          group="notification"
          position="bottom right"
          width="325"
          animation-type="velocity"
        />
        <Toast />
        <AutoLogoutCounter />
      </div>
      <router-link
        v-if="isConversationalCommerceButton"
        :to="{ name: 'ConversationalCommerce' }"
        tag="button"
        class="btn rounded-circle bg-white position-fixed"
        id="conversational-commerce-btn"
      >
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import $ from "jquery";
import _ from "lodash";
import MyPlanIcon from "@/components/my-plan/my-plan-icon";
import AutoLogoutCounter from "@/components/common/AutoLogoutCounter";
import PayoutRequirementsReminder from "@/components/onboarding/PayoutRequirementsReminder";
import "@/plugins/vue-head";
import { useIdle } from "@vueuse/core";
import Toast from '@/components/common/Toast';
import commonMixins from "@/mixins/common";

const idleTime =
  process.env.VUE_APP_IDLE_TIME == null
    ? 3660000
    : parseInt(process.env.VUE_APP_IDLE_TIME) + 60000;
console.log(idleTime);
const { idle, lastActive } = useIdle(idleTime);

window.jQuery = $;
require("jquery-slimscroll");

$(function () {
  const sidebar = document.querySelector("#sidebar");

  $(sidebar).slimScroll({
    height: "100%",
    color: "#DDE7ED",
  });
});

export default {
  name: "app",
  components: { MyPlanIcon, AutoLogoutCounter, PayoutRequirementsReminder, Toast },
  mixins: [commonMixins],
  head: {
    script: function () {
      let scripts = [];

      switch (process.env.VUE_APP_MODE) {
        case "Production":
        case "Release":
          scripts = [
            {
              src: "//cdnt.netcoresmartech.com/smartechclient.js",
            },
            {
              src: "//js-na1.hs-scripts.com/21165192.js",
              id: "hs-script-loader",
              async: true,
              defer: true,
            },
          ];
          break;
        case "Staging":
          scripts = [
            {
              src: "//cdnt.netcoresmartech.com/smartechclient.js",
            },
            {
              src: "//js-na1.hs-scripts.com/39620545.js",
              id: "hs-script-loader",
              async: true,
              defer: true,
            },
          ];
          break;
        default:
          scripts = [
            {
              src: "//js-na1.hs-scripts.com/39620545.js",
              id: "hs-script-loader",
              async: true,
              defer: true,
            },
          ];
      }

      return scripts;
    },
  },
  data() {
    return {
      isToggled: false,
      isOffset: false,
      showTopUp: false,
      env: process.env.VUE_APP_MODE,
      subdomain: null,
      withFreeTrial: false,
      freeTrialDays: "",
      idleTime:
        process.env.VUE_APP_IDLE_TIME == null
          ? 3660000
          : parseInt(process.env.VUE_APP_IDLE_TIME) + 60000,
      refreshTokenTime:
        process.env.VUE_APP_REFRESH_TOKEN_TIME == null
          ? 1800000
          : process.env.VUE_APP_REFRESH_TOKEN_TIME,
      transitionName: null,
      idle: idle,
      lastActive: lastActive,
      idleChecker: true,
    };
  },
  created: async function () {
    window.hsConversationsSettings = {
      loadImmediately: false,
    };

    window.hsConversationsOnReady = [
      () => {
        if (this.isLogin) {
          window.hsConversationsSettings.identificationEmail = this.user.email;
          if (this.hubspotToken)
            window.hsConversationsSettings.identificationToken =
              this.hubspotToken;
          window.HubSpotConversations.widget.load();
        }
      },
    ];

    this.repositionBottomActions();

    this.changeFavIcon();
    if (this.isLogin) {
      this.getSubdomainUrl();
      this.$store.dispatch("merchants/fetchMaintenance");
      this.refreshToken();
      this.$root.$on("resetIdle", () => {
        this.idleChecker = true;
      });
      await this.$store.dispatch("auth/getTopUps");

      if (this.$route.path !== "/account/profile") {
        await this.assignMerchantDetail();

        if (this.isSuspended) this.$router.push({ name: "MyPlanDetails" });

        // if (this.detail.registration_channel !== "Web" && this.detail.registration_channel !== "Superadmin") {
        //   this.$store.commit("myPlan/setTabs", this.myPlanTabs.slice(1));

        //   if (this.$route.name === "MyPlanDetails")
        //     this.$router.push({ name: "MyPlanBillingHistory" });
        // }
      }
    }

    if (this.subscriptionDetails != null) {
      const days = this.subscriptionDetails.free_trial_days;

      if (this.subscriptionDetails.with_free_trial && days) {
        this.freeTrialDays = `${days} day${days === 1 ? "" : "s"} left`;
        this.withFreeTrial = true;
      } else {
        this.withFreeTrial = false;
      }
    } else {
      this.withFreeTrial = false;
    }

    if (window.smartech) {
      if (this.hasAccess("fulfillment") && this.hasTopup("estore")) {
        window.smartech("dispatch", "Element Visibility", {
          value: "Order Fulfillment Navigation Link",
        });
      }
    }
  },
  mounted() {
    this.$root.$on("subscriptionCancelled", () => this.logout());

    if (
      process.env.VUE_APP_MODE === "Staging" ||
      process.env.VUE_APP_MODE === "Production"
    ) {
      const isSmartech = setInterval(() => {
        if (window.smartech) {
          window.smartech("create", process.env.VUE_APP_SMARTECH_CLIENTKEY);
          window.smartech("register", process.env.VUE_APP_SMARTECH_SITEID);
          if (this.isLogin) window.smartech("identify", this.user.uuid);
          clearInterval(isSmartech);
        }
      }, 300);
    }

    if (this.isSegmentAnalyticsReady) {
      window.analytics._writeKey = process.env.VUE_APP_SEGMENT_API_KEY;
      window.analytics.load(process.env.VUE_APP_SEGMENT_API_KEY);
    }
  },
  beforeDestroy() {
    this.$root.$off("subscriptionCancelled");
  },
  computed: {
    ...mapState("auth", {
      isLogin: (state) => state.login,
      user: (state) => state.user,
      enabledTopUps: (state) => state.enabledTopUps,
      merchant: (state) => state.merchant,
      hasPasswordUpdated: (state) => state.hasPasswordUpdated,
      currentStep: (state) => state.currentStep,
      planId: (state) => state.planId,
      onlineStoreVisibility: (state) => state.onlineStoreVisibility,
      isCartLinkingEnabled: (state) => state.isCartLinkingEnabled,
      hubspotToken: (state) => state.hubspotToken,
    }), // ...mapState("auth", ["hasPasswordUpdated", "user", "currentStep"])
    ...mapState("accountProfile", ["detail", "subscriptionDetails"]),
    ...mapState("merchants", {
      maintenance: (state) => state.maintenance,
      moduleList: (state) => state.moduleList,
    }),
    ...mapState("analytics", ["isSegmentAnalyticsReady"]),
    ...mapState("myPlan", {
      myPlanTabs: (state) => state.tabs,
    }),
    modules() {
      let modules = [];

      if (this.moduleList) {
        const submoduleList = [];

        for (const module of this.moduleList) {
          const { submodules } = module;

          submoduleList.push(submodules.map((submodule) => submodule.code));
        }

        modules = [].concat.apply([], submoduleList);
      }

      return modules;
    },
    showToMerchant() {
      let merchants = [
        "58e46598-61d7-4145-a689-ec1dde4e1b36",
        "8a05fec0-8f07-40a8-8bc2-241af9f4db6d",
        "58e46598-61d7-4145-a689-ec1dde4e1b36",
        "2c13cdf7-c22c-4e35-9b0d-2e8a0c4847be",
        "cd33c82d-1a64-4265-8cce-abfe25f74a20",
        "d7192ffc-cc03-4ea4-bd1a-2b7d6d730575",
        "3fb51834-e544-41ac-8ca0-7717e83dfc40",
        "6c3c216c-2f00-4544-b058-0e68f604bc77",
      ];
      if (this.user === null) {
        return false;
      }
      return merchants.indexOf(this.user.merchant_uuid) !== -1;
    },
    hideMyOnlineStoreLink() {
      if (this.isFlashPlan) return true;

      try {
        return !JSON.parse(this.onlineStoreVisibility);
      } catch {
        return false;
      }
    },
    racksCustomized() {
      let merchants = [
        "aa1c538b-df7e-4654-be6e-d7e6f5977d53",
        "6e277127-5e4b-48aa-a15c-0e1757d3a5a2",
      ];
      if (this.user === null) {
        return false;
      }
      return merchants.indexOf(this.user.merchant_uuid) !== -1;
    },
    isSuspended: {
      get() {
        return this.detail.contract_status === "suspended";
      },
      set(status) {
        return status;
      },
    },
    ...mapState("accountExtensions", ["errors", "form"]),
    ...mapGetters("accountProfile", ["planDetails"]),
    ...mapGetters("auth", ["cmsPermissions", "isAdmin"]),
    isFlashPlan() {
      return this.planDetails && this.planDetails.code === "flash";
    },
    isSidebar: {
      get() {
        return "sidebar" in this.$route.meta ? this.$route.meta.sidebar : true;
      },
      set(status) {
        return status;
      },
    },
    isHeader: {
      get() {
        return "header" in this.$route.meta ? this.$route.meta.header : true;
      },
      set(status) {
        return status;
      },
    },
    isConversationalCommerceButton: {
      get() {
        if (this.$route.name === "Orders") {
          if (!(this.$route.name !== "ConversationalCommerce" && this.isLogin))
            return false;

          if (this.isCartLinkingEnabled == false) return false;

          if (this.moduleList == null) return false;

          const ordersModule = this.moduleList.filter(
            (item) => item.code == "estore-orders-module"
          );

          if (ordersModule.length == 0) return false;

          const cartlinking = ordersModule[0].submodules.filter(
            (item) => item.code == "estore-orders.cartlinking:topup-estore"
          );

          if (cartlinking.length == 0) return false;

          return this.user.cms_permissions.includes(
            "estore-orders.cartlinking:topup-estore"
          );
        }

        return false;
      },
      set(status) {
        return status;
      },
    },
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapActions({
      assignMerchantDetail: "accountProfile/assignMerchantDetail",
    }),
    hasAccess(module) {
      if (!this.user) return false;

      const hasModule = this.modules.some((m) => m.includes(module));
      const hasPermission = this.cmsPermissions.some((permission) =>
        permission.includes(module)
      );

      return this.user.role === "admin"
        ? hasModule
        : hasModule && hasPermission;
    },
    sidebarToggle: function () {
      if (window.innerWidth > 992) {
        if (this.isToggled === true) {
          this.isToggled = false;
        } else {
          this.isToggled = true;
        }
      } else {
        this.isToggled = true;

        if (this.isOffset === true) {
          this.isOffset = false;
        } else {
          this.isOffset = true;
        }

        if (document.body.style.overflow === "") {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = null;
        }
      }
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    hasTopup(module) {
      return this.enabledTopUps.includes(module);
    },
    redirectTo(parentPath) {
      if (!this.isLogin) {
        return "/";
      }
      let newPath = "/";
      this.$router.options.routes.some((route) => {
        if (parentPath === route.path) {
          newPath = "/";
          route.meta.routeGroup.some((routeGroup) => {
            let moduleAccessIndex = _.findIndex(
              this.user.role === "admin"
                ? this.modules
                : this.user.cms_permissions,
              function (data) {
                return data.includes(routeGroup.access);
              }
            );
            if (moduleAccessIndex !== -1) {
              newPath = routeGroup.path;
              return true;
            }
          });
        }
      });
      return newPath;
    },
    restrictMarketplace() {
      if (this.planId == 5) return true;

      return false;
    },
    changeFavIcon() {
      if (this.planId == 5) {
        const link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/png";
        link.rel = "icon";
        link.href = "img/icons/zeal-logo.png";
        document.getElementsByTagName("head")[0].appendChild(link);

        $("link[rel*='icon']").attr("href", "/img/icons/zeal-logo.png");
      }
    },
    async getSubdomainUrl() {
      await this.$store
        .dispatch("accountExtensions/getSubdomainUrl")
        .then(() => {
          if (this.form) {
            if (this.form.merchant_subdomain) {
              let url = this.form.merchant_subdomain;
              let res = url.lastIndexOf("/");
              this.subdomain = url.substring(res + 1);
            } else if (this.form.customer_subdomain) {
              let url = this.form.customer_subdomain;
              let res = url.lastIndexOf("/");
              this.subdomain = url.substring(res + 1);
            }
          }
        });
    },
    GAEvent(ga_category, ga_action) {
      this.$ga.event(ga_category, ga_action, this.user.uuid, 1);
    },
    // refreshTime() {
    //     let autologout = setInterval(() => {
    //         if (!this.$store.state.idleVue.isIdle) {
    //           this.idleTime = moment().add(process.env.VUE_APP_IDLE_TIME, 'milliseconds');
    //           console.log(this.idleTime);
    //         } else {
    //           console.log(this.idleTime <= moment() + ' - ' + moment());
    //             if (this.idleTime <= moment()) {
    //                 this.$root.$emit("bv::show::modal", "logout-counter");
    //                 clearInterval(autologout);
    //             }
    //         }
    //     }, 1000);
    // },
    refreshToken() {
      let refreshToken = setInterval(async () => {
        if (this.isLogin) {
          clearInterval(refreshToken);
          this.refreshTokenTime = process.env.VUE_APP_REFRESH_TOKEN_TIME;
          await this.$store.dispatch("auth/refreshToken");
          this.refreshToken();
        }
      }, process.env.VUE_APP_REFRESH_TOKEN_TIME);
    },
    sendAnalyticsEvent(moduleName) {
      if (moduleName) {
        if (this.isSegmentAnalyticsReady) {
          window.analytics.track("Module Navigation", {
            title: moduleName,
          });
        }

        if (this.env === "Production")
          this.GAEvent(`CMS ${moduleName} Menu`, "click");
      }
    },
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        if (document.querySelector(".icon-close") != null) {
          document.querySelector(".icon-close").click();
        }
      }

      if (to.name === "ConversationalCommerce")
        this.transitionName = "slideLeft";

      this.$nextTick(() => {
        if (this.$route.name === "ConversationalCommerce")
          this.transitionName = "slideRight";
        else this.transitionName = null;
      });

      this.repositionBottomActions();
    },
    maintenance: function () {
      if (this.maintenance && !this.$route.path.includes("maintenance")) {
        this.$router.push("/maintenance");
      }
    },
    isLogin(isLogin) {
      if (isLogin) window.HubSpotConversations.widget.load();
      else {
        window.HubSpotConversations.clear();
        window.HubSpotConversations.widget.remove();
      }
    },
    // "$store.state.idleVue.isIdle" (value) {
    //   if (value && this.isLogin) {
    //     this.$root.$emit("bv::show::modal", "logout-counter");
    //   }
    // }
    "idle.value"(idle) {
      if (idle && this.isLogin) {
        this.idleChecker = false;
        this.$root.$emit("bv::show::modal", "logout-counter");
      }
    },
  },
};
</script>

<style lang="scss">
@import "./assets/scss/app.scss";

.nav-li {
  position: relative;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background-color: #fff;
  cursor: not-allowed;
}

#notifications .dropdown-toggle {
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}

.badge-secondary {
  border-radius: 0 0.25rem 0.25rem 0;
  padding: 0.5em 1em;
}
.badge-dark {
  border-radius: 0.25rem 0 0 0.25rem;
  padding: 0.5em 1em;
}

.free-trial {
  float: right;
}

.white {
  background-color: white;
}

#conversational-commerce-btn {
  bottom: 85px;
  right: 13px;
  width: 64px;
  height: 64px;
  background: url("~@/assets/images/icons/message-circle.svg") no-repeat center;
  box-shadow: 0px 4px 30px 5px rgba(104, 105, 123, 0.3);
  z-index: 3;
}

.slideLeft-enter-active,
.slideRight-enter-active {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.slideLeft-leave-active {
  animation: slideLeft 0.3s ease-in;
}

@keyframes slideLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.slideRight-leave-active {
  animation: slideRight 0.3s ease-in;
}

@keyframes slideRight {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
</style>